import { makeStyles } from '@material-ui/core';
import { MNOSuspendState } from '../../types';
import { sortMnoList } from '../../../../../utils';

const ColumnCount = 4;

const useStyles = makeStyles({
  container: {
    display: 'grid',
    gridTemplateColumns: `repeat(${ColumnCount}, 1fr)`,
    rowGap: '9px',
  },
  item: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '7px',
    boxSizing: 'border-box',
    fontFamily: 'Roboto',
    fontWeight: 700,
    fontSize: '12px',
    lineHeight: '14px',
    color: '#68737A',
  },
  padded: {
    paddingLeft: '20%',
    borderLeft: '1px solid #C0CCD4',
  },
  name: {
    fontWeight: 500,
    color: '#D41C54',
    '&.inactive': {
      color: '#68737A',
    },
  },
});

interface Props {
  mnos: MNOSuspendState[];
}

const BrandSuspendedStatus: React.FC<Props> = ({ mnos }) => {
  const classes = useStyles();

  const newMonsList = sortMnoList(mnos, ['displayName']);
  const rows = Math.ceil(newMonsList.length / ColumnCount);

  return (
    <div className={classes.container} data-testid="brandSuspendedStatus">
      {new Array(rows).fill(0).map((row, rowIndex) =>
        new Array(ColumnCount).fill(0).map((column, columnIndex) => {
          const mno = newMonsList[rowIndex + columnIndex * rows];
          return mno ? (
            <div
              data-testid={`brandSuspendedStatusSuspendedBrand-${mno?.displayName?.replace(
                /\s/g,
                ''
              )}`}
              key={mno.networkId}
              className={`${classes.item} ${
                columnIndex % ColumnCount > 0 ? classes.padded : ''
              }`}
            >
              <span
                className={`${classes.name} ${
                  typeof mno.suspended !== 'boolean' ? 'inactive' : ''
                }`}
              >
                {mno.displayName}
              </span>
              <span>
                {mno.suspended === true
                  ? 'Suspended'
                  : mno.suspended === false
                  ? 'Not Suspended'
                  : 'N/A'}
              </span>
            </div>
          ) : (
            <div
              key={`mno-${rowIndex + columnIndex * rows}`}
              className={classes.padded}
            />
          );
        })
      )}
    </div>
  );
};

export default BrandSuspendedStatus;
